export const TabOptions = [
  'Newest', 'MostViews', 'Recommended', 'BestSelling'
]